import react from "react";
import { CountdownTimer } from "./Timer";
import imgLeft from "../images/couple.jpg";
import imgCenter from "../images/image1.jpg";
import imgRight from "../images/image2.jpg";
import { useState } from "react";

export default function RSVP() {
  const [selectedImg, setSelectedImg] = useState(null);

  return (
    <div className="rsvp">
      {/* LIGHTBOX POPUP */}
      {selectedImg && (
        <div className="lightbox" onClick={() => setSelectedImg(null)}>
          <img src={selectedImg} className="lightbox-img" />
        </div>
      )}
      <section className="lux-rsvp-section">
        <div className="container d-flex justify-content-center">
          <div className="lux-rsvp-card text-center">
            <h2 className="lux-rsvp-title">RSVP</h2>

            <p className="lux-rsvp-text">
              We're beyond excited to celebrate this special day with the people
              we care most.
            </p>

            <p className="lux-rsvp-text">
              Please let us know if you'll be joining us by clicking the RSVP
              button below or sending us a message through our Facebook account.
            </p>

            <p className="lux-rsvp-text">
              Kindly RSVP by <span className="lux-date">April 15, 2026</span>
            </p>

            <p className="lux-rsvp-text">
              We can't wait to share a day full of love, laughter and
              unforgettable memories with you!
            </p>

            <a
              href="https://forms.gle/fr1ctdndmXhJfGfY8"
              target="_blank"
              rel="noopener noreferrer"
              className="lux-rsvp-button"
            >
              RSVP HERE
            </a>
          </div>
        </div>
      </section>
      {/* <div className="rsvp-info">
        <div className="rsvp-content">
          <h1>RSVP</h1>
          <p>
            We're beyond excited to celebrate this special day with the people
            we care most.
          </p>
          <p>
            Please let us know if you'll be joining us by clicking the RSVP
            button on the side or sending us a message through our facebook
            account.
          </p>
          <p>
            Kindly RSVP by <p className="stand-out">March 30, 2026</p> We can't
            wait to share a day full of love, laughter and unforgettable
            memories with you!
          </p>
        </div>

        <a
          href="https://forms.gle/fr1ctdndmXhJfGfY8"
          target="_blank"
          rel="noopener noreferrer"
          id="btnRsvp"
        >
          RSVP HERE
        </a>
      </div> */}

      <div className="envelope">
        <div className="top-envelope"></div>

        <div className="mid-container">
          <img
            className="imgLeft"
            src={imgLeft}
            onClick={() => setSelectedImg(imgLeft)}
          />
          <img
            className="imgCenter"
            src={imgCenter}
            onClick={() => setSelectedImg(imgCenter)}
          />
          <img
            className="imgRight"
            src={imgRight}
            onClick={() => setSelectedImg(imgRight)}
          />

          <div className="right-envelope"></div>
          <div className="left-envelope"></div>
        </div>
      </div>
    </div>
  );
}
